export default __webpack_public_path__ + "static/media/profile3.df714e19.png";